import type { PatternId } from '../../data/boss';
import type { BossFight } from './boss-fight';
import type { PatternEnv } from './attacks';
import type { TickContext } from '../tick';

/**
 * Registry of the attack patterns that the concrete bosses fill (issue #89). A pattern is called once per tick
 * while its phase is active and the boss is not in transition, so it cannot attack during one. The framework
 * knows no pattern: a boss whose pattern is not registered simply does not attack.
 */
export type Pattern = (fight: BossFight, context: TickContext, env?: PatternEnv) => void;

const registry = new Map<PatternId, Pattern>();

export function registerPattern(id: PatternId, pattern: Pattern): void {
  registry.set(id, pattern);
}

export const patternFor = (id: PatternId): Pattern | undefined => registry.get(id);

/** For tests that register their own patterns. */
export function clearPatterns(): void {
  registry.clear();
}
